/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
export const PortalActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditPortalMerchantPage,
    openDeletePortalMerchantDialog,
    tabValues
  }
) => (
  <>
    <>
      <a
        title="Edit Merchant"
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditPortalMerchantPage(row.id,tabValues)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            title="Edit Merchant"
          />
        </span>
      </a>
      <a
        title="Delete Merchant"
        className="btn btn-icon btn-light btn-hover-info btn-sm"
        onClick={() => openDeletePortalMerchantDialog(row.id)}
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} title="Delete Merchant"/>
        </span>
      </a>
    </>
  </>
);
